import { reatomAsync, withDataAtom, withErrorAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";

// Whitelist разрешённых плейсхолдеров шаблона: статический справочник, бэк не
// меняет его в рамках сессии — withDataAtom держит ответ в атоме, пока вкладка
// жива, так что повторные маунты формы не дёргают сеть.
export const getTemplateVariablesRequest = reatomAsync(
  async (ctx) =>
    API.exporterQueueApi
      .exportControllerGetTemplateVariables({ signal: ctx.controller.signal })
      .then((response) => response.data),
  "getTemplateVariablesRequest",
).pipe(withDataAtom(null), withErrorAtom(), withAbort(), withIsLoadingAtom());
